import styled from 'styled-components';

export const AddEmployeeCostCenterModalElement = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  width: 50vw;
  max-width: 600px;
  @media screen and (max-width: 600px) {
    width: 100%;
  }
`;
